<div class="revels-container" style="display: flex; flex-direction: column;">
  
  <img src="assets/images/RevelBase_Choir2.png" alt="Revel Singers" class="choir-resources-image">
  
  <!-- Desktop: search + Add button inline -->
  <div *ngIf="!(isHandset$ | async)" class="search-and-add" style="display: flex; align-items: center; gap: 20px; margin-bottom: 10px;">
    <div class="search-revel" style="display: flex; align-items: center; gap: 8px;">
      <label for="revel-search" style="white-space: nowrap;">Search Revel:</label>
      <input
        id="revel-search"
        type="text"
        [(ngModel)]="searchQuery"
        (input)="searchRevels()"
        placeholder="Search by name or description"
        class="narrow-search"
        style="width: 250px;"
      />
    </div>
    <button *ngIf="currentUserIsAdmin" mat-raised-button color="primary" (click)="addRevel()">Add Revel</button>
  </div>

  <!-- Handset: match composers handset design -->
  <div *ngIf="isHandset$ | async" class="toolbar-row" style="display: flex; flex-direction: column; gap: 8px; margin-top: 12px; margin-bottom: 10px;">
    <div class="search-revel" style="display: flex; align-items: center; gap: 8px;">
      <label for="revel-search-handset" style="white-space: nowrap;">Search Revel:</label>
      <input
        id="revel-search-handset"
        type="text"
        [(ngModel)]="searchQuery"
        (input)="searchRevels()"
        class="handset-search"
        style="width: 100%; max-width: 320px;"
      />
    </div>
  </div>

  <!-- List of Revels -->
  <div class="table-scroll" style="overflow-x: hidden;" *ngIf="isHandset$ | async; else desktopTable">
    <table mat-table [dataSource]="filteredRevels" class="mat-elevation-z8" style="width: 100%;">
      <!-- Revel Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Revel Name</th>
        <td mat-cell *matCellDef="let revel">
          <a href="#" (click)="viewRevel(revel); $event.preventDefault()">{{ revel.revelName }}</a>
        </td>
      </ng-container>

      <!-- Revel Location Column -->
      <ng-container matColumnDef="location">
        <th mat-header-cell *matHeaderCellDef>Revel Location</th>
        <td mat-cell *matCellDef="let revel">{{ revel.revelLocation }}</td>
      </ng-container>

      <!-- Revel Date Column -->
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>Revel Date</th>
        <td mat-cell *matCellDef="let revel" class="nowrap">{{ revel.revelDate | date: 'yyyy-MM-dd' }}</td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>
          <span *ngIf="currentUserIsAdmin">Actions</span>
        </th>
        <td mat-cell *matCellDef="let revel">
          <ng-container *ngIf="currentUserIsAdmin">
            <button mat-button color="primary" (click)="editRevel(revel)">Edit</button>
            <button mat-button color="warn" (click)="deleteRevel(revel.id)">Delete</button>
          </ng-container>
        </td>
      </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <ng-template #desktopTable>
    <div class="table-scroll">
      <table mat-table [dataSource]="filteredRevels" class="mat-elevation-z8" style="width: 100%;">
        <!-- Revel Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Revel Name</th>
          <td mat-cell *matCellDef="let revel">
            <a href="#" (click)="viewRevel(revel); $event.preventDefault()">{{ revel.revelName }}</a>
          </td>
        </ng-container>

        <!-- Revel Location Column -->
        <ng-container matColumnDef="location">
          <th mat-header-cell *matHeaderCellDef>Revel Location</th>
          <td mat-cell *matCellDef="let revel">{{ revel.revelLocation }}</td>
        </ng-container>

        <!-- Revel Date Column -->
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Revel Date</th>
          <td mat-cell *matCellDef="let revel" class="nowrap">{{ revel.revelDate | date: 'yyyy-MM-dd' }}</td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>
            <span *ngIf="currentUserIsAdmin">Actions</span>
          </th>
          <td mat-cell *matCellDef="let revel">
            <ng-container *ngIf="currentUserIsAdmin">
              <button mat-button color="primary" (click)="editRevel(revel)">Edit</button>
              <button mat-button color="warn" (click)="deleteRevel(revel.id)">Delete</button>
            </ng-container>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </ng-template>
</div>

